<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card border">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Berita / Pengumuman</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'article'}">Data Berita / Pengumuman</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Tipe</label>
                                            <select class="form-select" v-model="form.type">
                                                <option value="">Pilih Tipe</option>
                                                <option value="news">Berita</option>
                                                <option value="announcement">Pengumuman</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6 mt-3">
                                            <label>Nama / Judul</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.name" :class="{ 'is-invalid': submitted && $v.form.name.$error }">
                                            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Nama Berita / Pengumuman Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group col-md-12 mt-3">
                                            <label>Deskripsi Singkat</label>
                                            <textarea rows="4" class="form-control" placeholder="Masukan Deskripsi singkat" v-model="form.short_description"></textarea>
                                        </div>

                                        <div class="form-group col-md-12 mt-3">
                                            <label for="exampleInputEmail1">Isi Berita / Pengumuman</label>
                                            <ckeditor v-model="form.description" :config="editorConfig"></ckeditor>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label for="exampleFormControlSelect1">Status</label>
                                            <select class="form-select" id="exampleFormControlSelect1" v-model="form.status">
                                                <option value="publish">Publish</option>
                                                <option value="draft">Draft</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'article'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required
    } from "vuelidate/lib/validators";
    
    export default {
        name: 'ArticleForm',
        metaInfo: {
            title: 'Form Berita / Pengumuman',
            titleTemplate: '%s - Gubuk Sains Prima'
        },
        created() {
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                label           : 'Tambah',
                form : {
                    id           : "",
                    name         : "",
                    status       : "draft",
                    short_description   : "",
                    description         : "",
                    type                : "",
                },
                submitted       : false,
                waiting         : false,
                editorConfig: {
                    toolbar :  [{
                        name: 'basicstyles',
                        items: ['Bold', 'Italic', 'Strike','Subscript','Superscript','-', 'RemoveFormat','SpecialChar','EqnEditor','PasteFromWord']
                        }, {
                        name: 'paragraph',
                        items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote']
                        }, {
                        name: 'links',
                        items: ['Link', 'Unlink']
                        }, {
                        name: 'insert',
                        items: ['Image', 'EmbedSemantic', 'Table']
                        }, {
                        name: 'tools',
                        items: ['Maximize']
                    }],
                    extraPlugins:'autoembed,embedsemantic,specialchar,image2,uploadimage,uploadfile,widget',
                    imageUploadUrl: process.env.VUE_APP_APIHOST+'uploader/images',
                    uploadUrl: process.env.VUE_APP_APIHOST+'uploader/files',                    
                }
            }
        },
        validations: {
            form: {
                name: {
                    required
                }
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('name', this.form.name);
                    formData.append('status', this.form.status);
                    formData.append('short_description', this.form.short_description);
                    formData.append('description', this.form.description);
                    formData.append('type', this.form.type);

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/article/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'article' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/article/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id                = getResponse.id;
                            this.form.name              = getResponse.name;
                            this.form.status            = getResponse.status;
                            this.form.short_description = getResponse.short_description;
                            this.form.description       = getResponse.description;
                            this.form.type              = getResponse.type;
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'article' });
                                }
                            });
                        }
                    });
                }
            }
        }
    }
</script>